import type { CompanyFilterStore } from "./types";

export const selectAppliedFilters = (s: CompanyFilterStore) => s.appliedFilters;
export const selectPersistedFilters = (s: CompanyFilterStore) =>
  s.persistedFilters;

export const selectHasUnsavedChanges = (s: CompanyFilterStore): boolean =>
  JSON.stringify(s.appliedFilters) !== JSON.stringify(s.persistedFilters);

/** True when the draft edits have not yet been applied (manual confirm flow). */
export const selectHasPendingChanges = (s: CompanyFilterStore): boolean =>
  JSON.stringify(s.draftFilters) !== JSON.stringify(s.appliedFilters);
